// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BeltPickerController from "./belt_picker_controller"
application.register("belt-picker", BeltPickerController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChapterNavigationController from "./chapter_navigation_controller"
application.register("chapter-navigation", ChapterNavigationController)

import CountInModalController from "./count_in_modal_controller"
application.register("count-in-modal", CountInModalController)

import CourseLessonController from "./course_lesson_controller"
application.register("course-lesson", CourseLessonController)

import CourseOverviewController from "./course_overview_controller"
application.register("course-overview", CourseOverviewController)

import FiveSecondTestController from "./five_second_test_controller"
application.register("five-second-test", FiveSecondTestController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GenderController from "./gender_controller"
application.register("gender", GenderController)

import MenuToggleController from "./menu_toggle_controller"
application.register("menu-toggle", MenuToggleController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalFiltersController from "./modal_filters_controller"
application.register("modal-filters", ModalFiltersController)

import NamesController from "./names_controller"
application.register("names", NamesController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OpenModalFiltersController from "./open_modal_filters_controller"
application.register("open-modal-filters", OpenModalFiltersController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import ProfessorModeController from "./professor_mode_controller"
application.register("professor-mode", ProfessorModeController)

import RadioSubmitController from "./radio_submit_controller"
application.register("radio-submit", RadioSubmitController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import SchoolSearchController from "./school_search_controller"
application.register("school-search", SchoolSearchController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SignupDisabledController from "./signup_disabled_controller"
application.register("signup-disabled", SignupDisabledController)

import SlideToggleController from "./slide_toggle_controller"
application.register("slide-toggle", SlideToggleController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TrackingController from "./tracking_controller"
application.register("tracking", TrackingController)

import TrainingSessionListController from "./training_session_list_controller"
application.register("training-session-list", TrainingSessionListController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import WorkItemController from "./work_item_controller"
application.register("work-item", WorkItemController)

import WorkQueueController from "./work_queue_controller"
application.register("work-queue", WorkQueueController)
